'use client';

import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getMessageAssistQuota } from '@/lib/api/provider/messageAssistQuota';
import { queryKeys } from '@/lib/query';

export const useMessageAssistQuota = (options?: { enabled?: boolean }) => {
  const query = useQuery({
    queryKey: queryKeys.provider.messageAssistQuota(),
    queryFn: getMessageAssistQuota,
    staleTime: 60 * 1000,
    enabled: options?.enabled ?? true
  });

  const queryClient = useQueryClient();
  const refresh = () =>
    queryClient.invalidateQueries({
      queryKey: queryKeys.provider.messageAssistQuota()
    });

  return { ...query, refresh };
};
